import { AsyncAjaxPost, AsyncAjaxPatch } from "../Common/AsyncAjaxService";
import { utils, ResponseCode } from "../../utils/Utils";
import React, { useState, Fragment, useEffect } from "react";
import { unmountComponentAtNode, createPortal } from "react-dom";
import VGPopUp from "../Controls/VGPopUp";
import Loader from "../Common/Loader";
import '../Zenswipe/zenswipe.js';
import store from '../../app/store'
import useGenerateToken from "components/Hook/useGenerateToken";

const DomainRenewPopup = (props) => {
    const { CurrencySymbol } = store.getState().Business;

    const [isLoading, setLoading] = useState(false);
    const [showcc, setshowcc] = useState(false);
    
    const cardTokenDetails = props.cardTokenDetails;
    const domainName = props.domainName;
    const expiredOn = props.expiredOn;
    const amount = props.amount;
    const BusinessID = props.businessID
    const UserID = props.userID;
    const ReactBusinessId = props.reactBusinessId;
    const ReactUserID = props.reactUserID;

    const [isExistingCard, setisExistingCard] = useState(true);

    const VagaroAPIEnum = {
        StartRenewDomain: "merchants/" + BusinessID + "/domains/",
        UpdateOwnerCardDetails: BusinessID + "/zenswipe/updateownercarddetails"
    };

    useEffect(() => {
        if ((typeof cardTokenDetails.current != 'undefined' && cardTokenDetails.current != null && cardTokenDetails.current != "")
            && (typeof cardTokenDetails.current.cardTokenID === 'undefined' || cardTokenDetails.current.cardTokenID === null || cardTokenDetails.current.cardTokenID === "")) {
            GetCCIframe();
        }
    }, []);

    const ShowLoadingPanel = (FlgShow) => {
        setLoading(FlgShow);
    }

    window.onGetTokenCallback = (res) => {     
        if (res.data.custom_code == ResponseCode.Success) {
            setLoading(true);
            if (utils.Validate(res.data.data) && res.data.data.save_card === true) {
                setLoading(true);
                if (utils.Validate(res.data.data)) {
                    UpdateOwnerCardDetails(res.data.data);
                }
                else {
                    setLoading(false);
                }
            }
            else {
                EnableAutoRenew(false);
                setLoading(false);
            }
        }
        else {
            setLoading(false);
            if (utils.Validate(res.data.Message)) {
                utils.ShowAlert("Alert!", res.data.Message, "OpenDialog1");
            }
        }
    }

    const UpdateOwnerCardDetails = async (ZenswipeResponse) => {
        const access_token = await useGenerateToken(props.dispatch);
        if (utils.Validate(access_token)) {
            setLoading(true);
            const Requestdata = {};
            Requestdata.CardTokenID = ZenswipeResponse.card_token;
            Requestdata.CVV = ZenswipeResponse.cvv;
            Requestdata.CCFirstName = ZenswipeResponse.first_name;
            Requestdata.CCLastName = ZenswipeResponse.last_name;
            Requestdata.CreditCardType = ZenswipeResponse.cc_type;
            Requestdata.CreditCardNumber = ZenswipeResponse.cc_no;
            await AsyncAjaxPost(
                VagaroAPIEnum.UpdateOwnerCardDetails,
                Requestdata,
                access_token,
                function onSuccess(data) {
                    if (
                        data != null &&
                        data.data != null &&
                        data.data.responseCode == ResponseCode.Success
                    ) {
                        if (data != null && data.data != null && data.data.data != null && data.data.data === true) {
                            EnableAutoRenew(false);
                        }
                        else {
                            setLoading(false);
                        }
                    }
                    else {
                        setLoading(false);
                    }
                },
                function OnError(error) {
                    setLoading(false);
                    if (error != undefined && error.response != undefined && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors.exception != undefined) {
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Update Card Details",
                            ReactBusinessId,
                            ""
                        );
                        utils.ShowAlert("Warning", error.response.data.errors.exception, "OpenDialog");
                    }
                }
            );
        }
        else {
            utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
        }
    }

    const GetCCIframe = async () => {
        let access_token = await useGenerateToken(props.dispatch);
        if (utils.Validate(access_token) && (typeof cardTokenDetails.current != 'undefined' && cardTokenDetails.current != null && cardTokenDetails.current.merchantTokenID != null && cardTokenDetails.current.merchantTokenID != "")) {
            setLoading(true);
            setshowcc(true);
            window.vui.loader = ShowLoadingPanel;
            window.vui.getTypeFramewithCardOnFile("dvrenewccframe", 450, cardTokenDetails.current.merchantTokenID, '100%', '', 1, 'React Domain', true, "0", "", access_token, BusinessID);
        }
        else {
            utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
        }
    };

    window.onRequiredCallback = (res) => {
        if (res.eventType === "required") {
            setLoading(false);
        }
    }

    const EnableAutoRenew = async (ischecked) => {
        const access_token = await useGenerateToken(props.dispatch);
        if (utils.Validate(access_token)) {
            if (showcc && ischecked) {
                window.vui.frame.zenswipe.submit();
                setLoading(false);
                return;
            }
            setLoading(true);
            const Requestdata = {};
            Requestdata.UserID = UserID;
            await AsyncAjaxPatch(
                VagaroAPIEnum.StartRenewDomain + domainName + "/autorenew/on",
                Requestdata,
                access_token,
                function onSuccess(data) {
                    try {
                        if (
                            data != null &&
                            data.data != null &&
                            data.data.responseCode == ResponseCode.Success
                        ) {
                            if (data != null && data.data != null && data.data.data != null && data.data.data.status === true) {
                                PopupClose();
                                props.PurchasedDomainList();
                                setLoading(false);
                                props.setIsMessageOpen(true);
                                props.setMessage(domainName + " has been enable renewed successfully.");
                            }
                            else {
                                PopupClose();
                                setLoading(false);
                            }
                        }
                        else {
                            PopupClose();
                            setLoading(false);
                            utils.ShowAlert("Message", data.data.message, "OpenDialog");
                        }
                    }
                    catch (error) {
                        setLoading(false);
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Enable Auto Renew Domain",
                            domainName,
                            ""
                        );
                        utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    }
                },
                function OnError(error) {
                    PopupClose();
                    setLoading(false);
                    if (error != undefined && error.response != undefined && error.response.data != undefined && error.response.data.errors != undefined && error.response.data.errors.exception != undefined) {
                        utils.appInsightTrack(
                            ReactBusinessId,
                            ReactUserID,
                            "Enable Auto Renew Domain : " + error.response.data.errors.exception,
                            domainName,
                            ""
                        );
                        utils.ShowAlert("Warning", error.response.data.errors.exception, "OpenDialog");
                    }
                }
            );
        }
        else {
            utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
        }
    }

    const ExistingCardSelection = async () => {
        if (!isExistingCard) {
             setshowcc(false)
             setisExistingCard(true);
        }
   }

   const NewCardSelection = async () => {
        if (isExistingCard) {
             setshowcc(true);
             setisExistingCard(false);
             GetCCIframe();
        }
   }

    const RenewDomainBody = () => {
        return (
            <Fragment>
                {isLoading && <Loader />}
                <div className="alertContent">
                    <p>Your domain <b>{domainName.toLowerCase()}</b> will auto renew on <b>{expiredOn}</b> and be charged <b>{CurrencySymbol}{amount}</b> with this card on file.</p>
                </div>
                {typeof cardTokenDetails.current.cardTokenID != 'undefined' && cardTokenDetails.current.cardTokenID != null && cardTokenDetails.current.cardTokenID != "" &&
                    <Fragment>
                        <div className="domain-section-title">
                            Payment Method
                        </div>
                        <div className="domain-saved-card">
                            <div className="domain-saved-card-items">
                                <a href="javascript:void(0)"
                                    className={!showcc ? "domain-saved-payment-item item-selected" : "domain-saved-payment-item"}
                                    onClick={() => ExistingCardSelection()}
                                >{cardTokenDetails.current.creditCardType} ending in {cardTokenDetails.current.creditCardNumber}
                                </a>
                                <a href="javascript:void(0)"
                                    className={showcc ? "domain-saved-payment-item item-selected" : "domain-saved-payment-item"}
                                    onClick={(e) => NewCardSelection()}>
                                    New Payment Method
                                </a>
                            </div>
                        </div>
                    </Fragment>
                }
                {showcc &&
                    <div className="iframe-container">
                        <div id="dvrenewccframe"></div>
                    </div>
                }
            </Fragment>

        )
    }

    const RenewDomainFooter = () => {
        return (
            <Fragment>
                <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                <button className="w-button w-button-primary" onClick={() => EnableAutoRenew(true)}>Enable Auto Renew</button>
            </Fragment >
        )
    }

    const PopupClose = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog"));
    };

    return createPortal(
        <VGPopUp
            id={"EditTemplatePopup"}
            show={true}
            title={"Renew Domain"}
            onHide={PopupClose}
            size="sm"
            body={RenewDomainBody()}
            dialogClassName="vg-w480"
            footer={RenewDomainFooter()}
            isShowFooter={true}
            backdrop={true}
            isRemoveTabModalIndex={true}
        />,
        document.getElementById("OpenDialog")
    )
}

export default DomainRenewPopup;
